import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import './css/Sidebar.css'
import Logo from './Logo/Logo'
import NavigationMenu from './NavigationMenu/NavigationMenu'
import { FULL_PAGE_PATHS } from '../../../app/routes'

const SideBar = () => {
    const isFullPage = useRouteMatch(FULL_PAGE_PATHS)
    if (isFullPage) {
        return null
    }
    return (
        <div className="vertical-menu">
            <Logo />
            <NavigationMenu />
        </div>
    )
}

export default SideBar
